import React from "react";

const DashboardCardLoader = ({ className = "" }) => (
	<div className={`dashboard-card-loader ${className}`}>
		<i className="fa fa-spinner fa-spin" />
		<span>Loading</span>
	</div>
);

export default DashboardCardLoader;
